import Highlighter from 'react-highlight-words'
import './index.scss'

export default function CustomOption(props) {
  const { label, data, selectOption } = props

  return (
    <button className="CustomOption-wrapper" {...props} onClick={data?.onClick ?? (() => selectOption(data))}>
      <p>
        <Highlighter
          highlightClassName="textHighlight"
          searchWords={[data?.searchTerm]}
          autoEscape={true}
          textToHighlight={label}
        />
      </p>
      {Boolean(data?.subLabel) && <span className="subLabel">{data?.subLabel}</span>}
    </button>
  )
}
